<template>
  <v-hover v-slot="{ hover }" open-delay="200">
    <v-fade-transition hide-on-leave>
      <v-btn icon v-if="!hover">
        <v-icon>
          mdi-magnify
        </v-icon>
      </v-btn>
      <div style="width:300px" v-else>
        <v-text-field
          outlined
          v-model="model"
          single-line
          prepend-inner-icon="mdi-magnify"
          background-color="#00725B"
          hide-details
          clearable
          @click:clear="onClear"
          autofocus
          dense
          placeholder="Tìm kiếm"
        ></v-text-field
      ></div>
    </v-fade-transition>
  </v-hover>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
  },
  data: () => ({}),
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    onClear() {
      this.model = ''
    },
  },
}
</script>

<style scoped></style>
